import { store } from '@/store'
import { forceSearchParamsLoader } from '../utils'
import { assetApi } from '@/store/services'

export const AssetListLoader = (args) => {
  const initial = {
    page: 1,
    per_page: 10,
    'order[field]': 'created_at',
    'order[sort]': 'desc'
  }
  return forceSearchParamsLoader({ initial, args }, (searchParams) => store.dispatch(assetApi.endpoints.getAssets.initiate(`?${searchParams}`)).unwrap())
}

export const AssetEditLoader = (args) => {
  const { params } = args

  return store.dispatch(
    assetApi.endpoints.getAsset.initiate(params?.id)
  ).unwrap()
}
